import { render, staticRenderFns } from "./ChooseWineSearch.vue?vue&type=template&id=105c5142&"
import script from "./ChooseWineSearch.vue?vue&type=script&lang=js&"
export * from "./ChooseWineSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports